var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2255_478)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 44,
    height: 44,
    rx: 12,
    fill: "#B31017",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8928 24.2902C28.9594 23.8248 29.1017 23.5681 29.3032 23.3954C29.6385 23.108 30.3629 22.85 32 22.85C33.637 22.85 34.3615 23.108 34.6968 23.3954C34.8986 23.5684 35.041 23.8256 35.1075 24.2924C34.2013 24.1895 33.1686 24.15 32 24.15C30.83 24.15 29.7977 24.1896 28.8928 24.2902ZM27.1589 24.6032C27.2028 23.6777 27.4267 22.7648 28.1968 22.1047C29.0282 21.3921 30.3037 21.15 32 21.15C33.6963 21.15 34.9718 21.3921 35.8032 22.1047C36.5763 22.7673 36.7989 23.6848 36.8416 24.614C37.7272 24.8609 38.4776 25.2342 39.0804 25.7977C40.2614 26.9016 40.6878 28.5595 40.8092 30.739C40.8357 30.8212 40.85 30.9089 40.85 31C40.85 31.1577 40.8469 31.3169 40.8387 31.4766C40.8466 31.7793 40.85 32.0911 40.85 32.4118C40.85 34.8466 40.5321 36.8446 39.0663 38.1541C37.6393 39.429 35.3374 39.85 32 39.85C30.3152 39.85 28.916 39.768 27.7712 39.5397C26.6222 39.3105 25.6702 38.9227 24.9347 38.2676C23.4552 36.95 23.15 34.8223 23.15 32C23.15 31.7798 23.1519 31.5639 23.156 31.3522C23.1517 31.2343 23.15 31.1167 23.15 31C23.15 30.9331 23.1577 30.868 23.1723 30.8055C23.2645 28.5722 23.6718 26.8572 24.9347 25.7325C25.5353 25.1975 26.2802 24.8408 27.1589 24.6032ZM24.857 31.341C24.9109 28.9193 25.2797 27.7017 26.0653 27.002C26.4964 26.618 27.1278 26.3222 28.1038 26.1276C29.084 25.932 30.3515 25.85 32 25.85C33.6493 25.85 34.9142 25.9322 35.8914 26.133C36.8623 26.3325 37.4892 26.6374 37.9196 27.0396C38.6917 27.7614 39.0646 29.0152 39.1368 31.459C39.1136 31.8253 39.0586 32.1213 38.9613 32.3695C38.837 32.6868 38.6282 32.9659 38.2262 33.2153C37.3434 33.763 35.5692 34.15 32.006 34.15C28.4432 34.15 26.6652 33.7631 25.7789 33.2147C25.375 32.9648 25.165 32.6851 25.04 32.368C24.9319 32.094 24.8755 31.7617 24.857 31.341ZM38.9826 34.743C38.8014 35.7423 38.4647 36.412 37.9337 36.8864C37.0274 37.696 35.3293 38.15 32 38.15C30.3515 38.15 29.084 38.068 28.1038 37.8725C27.1278 37.6778 26.4964 37.3821 26.0653 36.9981C25.5477 36.5371 25.211 35.8513 25.0262 34.7444C26.3757 35.5116 28.5684 35.85 32.006 35.85C35.4447 35.85 37.6357 35.5114 38.9826 34.743ZM29.15 32C29.15 31.5306 29.5306 31.15 30 31.15H34C34.4694 31.15 34.85 31.5306 34.85 32C34.85 32.4695 34.4694 32.85 34 32.85L30 32.85C29.5306 32.85 29.15 32.4695 29.15 32Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2255_478",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.552941 0 0 0 0 0.709804 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2255_478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2255_478",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.08680423cfa28795131a28042ec2f112.svg";
export { ForwardRef as ReactComponent };